import {
  normalizeResponseError,
  normalizeThrownError,
} from '@/context/services/normalizeError';
import { isSuccess } from '@/context/services/type';
import { useDeleteAdminInvoiceReport } from 'ap-openapi';
import { useCallback } from 'react';

export const useDeleteAdminInvoiceReportService = () => {
  const { mutateAsync: _mutateAsync } = useDeleteAdminInvoiceReport();

  const mutateAsync = useCallback(
    async (id: string) => {
      try {
        const resp = await _mutateAsync({ id });

        if (isSuccess(resp.status)) {
          return { status: 'success' as const, data: resp.data };
        }

        return {
          status: 'error' as const,
          errors: normalizeResponseError(resp.status, resp.data),
        };
      } catch (error) {
        return {
          status: 'error' as const,
          errors: normalizeThrownError(error),
        };
      }
    },
    [_mutateAsync]
  );

  return { mutateAsync };
};
